import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Brooke Clifton
 * id 15B2BA3F-53A2-4151-9B90-20000264FE54
 * name text-account
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/text-account.svg
 * tags
 * - Account / User 
 */
export const TextAccountIcon = createSvgIcon(<><path d="M21 5V7H3V5H21M3 17H12V15H3V17M3 12H21V10H3V12M18 14C19.11 14 20 14.9 20 16S19.11 18 18 18 16 17.11 16 16 16.9 14 18 14M14 22V21C14 19.9 15.79 19 18 19S22 19.9 22 21V22H14Z" /></>, 'TextAccountIcon');
export default TextAccountIcon